<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import cloneDeep from "lodash-es/cloneDeep";
import { styleZoom } from "@/common/utils/style";
// types
import type { ReportBlockType } from "@/common/types/report";

const emit = defineEmits(["block:update"]);

const props = defineProps<{
  block: ReportBlockType;
  selectedBlock: string | null;
  zoom: number;
}>();

const internalBlock = ref(cloneDeep(props.block));

watch(
  () => props.block,
  (newValue) => {
    internalBlock.value = cloneDeep(newValue);
  },
  { deep: true }
);

onMounted(() => {
  if (props.block) {
    internalBlock.value = cloneDeep(props.block);
  }
});
</script>

<template>
  <div class="text-block" :style="styleZoom(internalBlock?.style, zoom)">
    <div v-html="internalBlock.text"></div>
  </div>
</template>

<style lang="scss" scoped>
.text-block {
  min-height: 10px;
  word-break: break-word;
  padding: 3px;

  &:focus {
    outline: 2px dashed #007bff;
    outline-offset: 3px;
  }
}

:deep(p) {
  margin: 0;
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
}

:deep(.ql-container.ql-snow) {
  border: none;
}
</style>
